import React,{ useEffect, useMemo, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation, useSearchParams } from "react-router-dom";
import { s3ThemeAssetUrl } from "../../utils/themeAssets";

const FROM_MOBILE_APP_STORAGE_KEY = 'lcp_fromMobileApp';

/** Routes where the header Back button is hidden when opened from the mobile app WebView. */
function isHideBackTargetPath(pathname) {
  const p = pathname.replace(/\/+$/, '') || '/';
  if (p === '/' || p === '/login') return true;
  return ['/game', '/leaderboard', '/feedback'].includes(p);
}

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { status, user, error } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 

  const applyCustomTheme = (theme) => {
    if (!theme) return;
    const t = theme.colors && typeof theme.colors === "object" ? theme.colors : theme;
    if (t.text_color != null) document.documentElement.style.setProperty("--text-color", t.text_color);
    if (t.ui_color_1 != null) document.documentElement.style.setProperty("--ui-color-1", t.ui_color_1);
    if (t.ui_color_2 != null) document.documentElement.style.setProperty("--ui-color-2", t.ui_color_2);
    if (t.option_color != null) document.documentElement.style.setProperty("--option-color", t.option_color);
    if (t.option_text_color != null) document.documentElement.style.setProperty("--option-text-color", t.option_text_color);
  };
    
  useEffect(() => {
    if (/^\/login(?:\/)?$/.test(location.pathname)) return;
    if (themeStatus === "idle") {
      dispatch(fetchThemeData({ themeId: null }));
    }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    console.log(backButtonUrl);
    console.log(companyLogoUrl);
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])

  const fromMobileAppInUrl = searchParams.get('fromMobileApp') === 'true';
  useEffect(() => {
    if (!fromMobileAppInUrl) return;
    try {
      sessionStorage.setItem(FROM_MOBILE_APP_STORAGE_KEY, 'true');
    } catch (_) {
      /* ignore */
    }
  }, [fromMobileAppInUrl]);

  /** True when URL has fromMobileApp=true or we persisted it (e.g. after client-side navigation). */
  const isFromMobileApp = useMemo(() => {
    let fromSession = false;
    try {
      fromSession = sessionStorage.getItem(FROM_MOBILE_APP_STORAGE_KEY) === 'true';
    } catch (_) {
      fromSession = false;
    }
    return fromMobileAppInUrl || fromSession;
  }, [fromMobileAppInUrl, location.pathname]);

  const hideBackButton = useMemo(
    () => isFromMobileApp && isHideBackTargetPath(location.pathname),
    [isFromMobileApp, location.pathname]
  );

  useEffect(() => {
    if (!backUrl) return;

    const handleBrowserBack = () => {
      window.location.href = backUrl;
    };

    // Push a history entry so browser-back can be captured consistently.
    window.history.pushState({ lcpBackHandled: true }, "", window.location.href);
    window.addEventListener("popstate", handleBrowserBack);

    return () => {
      window.removeEventListener("popstate", handleBrowserBack);
    };
  }, [backUrl, location.pathname]);


  useEffect(() => {
    if (themeStatus !== "succeeded" || !themeData) return;
    applyCustomTheme(themeData);
    const body = document.body;
    const applyBodyBg = () => {
      const file =
        typeof window !== "undefined" && window.innerWidth <= 768
          ? themeData.background_mob
          : themeData.background_desk;
      const url = s3ThemeAssetUrl(file);
      if (url) {
        body.style.backgroundImage = `url(${url})`;
        body.style.backgroundSize = "cover";
        body.style.backgroundPosition = "center center";
        body.style.backgroundRepeat = "no-repeat";
        body.style.backgroundAttachment = "fixed";
        body.style.minHeight = "100vh";
      }
    };
    applyBodyBg();
    window.addEventListener("resize", applyBodyBg);
    return () => window.removeEventListener("resize", applyBodyBg);
  }, [themeStatus, themeData]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.('navigate_back');
  };

  return (
    <div className="ddd-user-shell">
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={logoUrl} className="logo-holder"  /></a>
        {!hideBackButton ? (
        <div className="back-holder">
       <a href={backUrl}><button className="back-default">Back</button></a> 
        </div>
        ) : null}
       
      </header>
      <div className="ddd-user-main">{children}</div>
    </div>
  );
}

export default USER;
